import React, {useContext} from "react";
import {BrandContext} from "@context/BrandContext";
import {UserContext} from "@context/UserContext";
import {ContentContext} from "@context/ContentContext";
import IconButton from "@common/IconButton";
import ButtonsGroup from "@common/ButtonsGroup";
import {FullscreenIcon, PrintIcon, ShareIcon, BookmarkAddIcon, DictionaryEditIcon, LinkIcon, NoteAddIcon} from "@common/icons";
import FloatingOpenRightNavMobile from "../nav/FloatingOpenRightNavMobile";
import {useScreenMode} from "@common/context/ScreenModeContext";

const LessonButtons = props => {
    const {singlePanel, activeTab, setBookmarkDialogOpen} = props;
    const {content, setDialogMediaObject} = useContext(ContentContext);
    const brandConfig = useContext(BrandContext);
    const {user} = useContext(UserContext);
    const {smallScreenMode} = useScreenMode();

    return (
        <ButtonsGroup role="menubar" className={(singlePanel ? "ch-tab-right-area" : "")}>
            {brandConfig.hasDesmos && (
                <>
                    {brandConfig.desmosTypes.includes('DESMOS_GRAPHING') && (
                        <IconButton className="ch-icon-btn-sm"
                                    tooltip="Desmos graphing calculator" placement="top"
                                    onClick={() => {setDialogMediaObject({mediaType: 'DESMOS', mediaSubType: 'DESMOS_GRAPHING', mediaName: 'Graphing calculator', conceptId: content.currentConcept.conceptId, isGenericCalculator: true})}}>
                            <img
                                src="/users/generalFiles/images/icons/desmos-icon-square-1024.png"
                                className="demos-icon" alt="Desmos graphing calculator"/>
                        </IconButton>
                    )}
                    {brandConfig.desmosTypes.includes('DESMOS_GEOMETRY') && (
                        <IconButton className="ch-icon-btn-sm"
                                    tooltip="Desmos geometry tool" placement="top"
                                    onClick={() => {setDialogMediaObject({mediaType: 'DESMOS', mediaSubType: 'DESMOS_GEOMETRY', mediaName: 'Geometry', conceptId: content.currentConcept.conceptId, isGenericCalculator: true})}}>
                            <img src="/users/generalFiles/images/icons/geometry-tool.png"
                                 className="demos-icon" alt="Desmos geometry tool"/>
                        </IconButton>
                    )}
                    {brandConfig.desmosTypes.includes('DESMOS_SCIENTIFIC') && (
                        <IconButton className="ch-icon-btn-sm"
                                    tooltip="Desmos scientific calculator" placement="top"
                                    onClick={() => {setDialogMediaObject({mediaType: 'DESMOS', mediaSubType: 'DESMOS_SCIENTIFIC', mediaName: 'Scientific calculator', conceptId: content.currentConcept.conceptId, isGenericCalculator: true})}}>
                            <img
                                src="/users/generalFiles/images/icons/scientific-calculator.png"
                                className="demos-icon" alt="Desmos scientific calculator"/>
                        </IconButton>
                    )}
                    {brandConfig.desmosTypes.includes('DESMOS_MATRIX') && (
                        <IconButton className="ch-icon-btn-sm"
                                    tooltip="Desmos matrix calculator" placement="top"
                                    onClick={() => {setDialogMediaObject({mediaType: 'DESMOS', mediaSubType: 'DESMOS_MATRIX', mediaName: 'Matrix calculator', conceptId: content.currentConcept.conceptId, isGenericCalculator: true})}}>
                            <img
                                src="/users/generalFiles/images/icons/desmos-matrix-calculator.png"
                                className="demos-icon" alt="Desmos matrix calculator"/>
                        </IconButton>
                    )}
                </>
            )}
            {user != undefined && !user.publicSession && (
                <>
                    {brandConfig.enablePrintLessonNotes && (
                        <>
                            <IconButton className="ch-icon-btn-sm"
                                        onClick={() => loadFullScreenLessonNotes(content.currentConcept.conceptGroupId, content.currentConcept.conceptId)}
                                        tooltip="Full screen" placement="top">
                                <FullscreenIcon />
                            </IconButton>
                            <IconButton className="ch-icon-btn-sm"
                                        onClick={() => printConcept(content.currentConcept.conceptId)}
                                        tooltip="Print" placement="top">
                                <PrintIcon />
                            </IconButton>
                        </>
                    )}
                    {brandConfig.enableContentNotes && (
                        <IconButton className="ch-icon-btn-sm js-addContentNote"
                                    disabled={(activeTab?.resourceType != 'TUTORIAL' && activeTab?.resourceType != 'QUESTION_CLUSTER' && singlePanel)}
                                    aria-pressed={false}
                                    tooltip="Add note" placement="top">
                            <NoteAddIcon />
                        </IconButton>
                    )}
                    {brandConfig.enableDeepLinking && (
                        <IconButton className="ch-icon-btn-sm"
                                    data-concept-id={content.currentConcept.conceptId}
                                    onClick={() => openLessonLinkDialog(content.currentConcept.conceptId)}
                                    tooltip="Share a link" placement="top">
                            <ShareIcon />
                        </IconButton>
                    )}
                    {brandConfig.enableBookmarks && (
                        <IconButton className="ch-icon-btn-sm"
                                    data-concept-id={content.currentConcept.conceptId}
                                    onClick={() => setBookmarkDialogOpen(true)}
                                    tooltip="Create a bookmark" placement="top">
                            <BookmarkAddIcon />
                        </IconButton>
                    )}
                    {brandConfig.enabledCurriculumSearching && content.currentConcept.curriculumLinkCount > 0 && (
                        <IconButton className="ch-icon-btn-sm"
                                    onClick={() => openCurriculumDialog(content.currentConcept.conceptId)}
                                    data-concept-id={content.currentConcept.conceptId}
                                    tooltip="Show curriculum links" placement="top">
                            <LinkIcon />
                        </IconButton>
                    )}
                    {user.roles.includes('ADMIN', 'ADMIN_CONTENT_MANAGER') && !user.actForUserId && (
                        <IconButton className="ch-icon-btn-sm js-editGlossaryTermsInLesson"
                                    tooltip="Edit Dictionary Terms" placement="top">
                            <DictionaryEditIcon />
                        </IconButton>
                    )}
                    {smallScreenMode &&
                        <FloatingOpenRightNavMobile />
                    }
                </>
            )}
        </ButtonsGroup>
    )
}

export default LessonButtons;